<template>
  <v-dialog v-model="open" max-width="600">
    <v-card>
      <v-card-title style="flex-wrap: nowrap; word-break: break-word">
        <div>
          Datenschutzhinweise für die UVI-Portalsoftware der Vivawest Energiedienstleistungen GmbH
        </div>
        <div>
          <v-btn @click="open = false" depressed icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <h3 class="mt-5 mb-3">Name und Kontaktdaten des Verantwortlichen</h3>

        <p>
          Verantwortlich für die Datenerhebung ist die Vivawest Energiedienstleistungen GmbH, vertreten durch die Geschäftsführung, Nordsternplatz 1, 45899 Gelsenkirchen, E-Mail: <a href="mailto:info.energiedienstleistungen@vivawest.de">info.energiedienstleistungen@vivawest.de</a>, Tel.-Nr. +49 209 35975 500.
        </p>

        <h3 class="mt-5 mb-3">Kontaktdaten des betrieblichen Datenschutzbeauftragten</h3>

        <p>
          Betrieblicher Datenschutzbeauftragter der Vivawest Energiedienstleistungen GmbH, c/o Vivawest Wohnen GmbH, Nordsternplatz 1, 45899 Gelsenkirchen, E-Mail: <a href="mailto:datenschutz@vivawest.de">datenschutz@vivawest.de</a>, Tel.-Nr. 0209/380-0.
        </p>

        <h3 class="mt-5 mb-3">Kategorien der personenbezogenen Daten, die verarbeitet werden</h3>

        <p>
          Vor- und Nachname, Kundennummer, Firmierung, Telefonnummer, E-Mail-Adresse, ggf. Vor- und Nachname sowie E-Mail-Adresse und Position von Mitarbeitern, Liegenschaftsnummer, Adresse der Liegenschaft (Straße, Hausnummer, Postleitzahl, Ort und Land), Adresse der Wohneinheit (Straße, Hausnummer, Postleitzahl, Ort und Geschosslage), Logo.
        </p>

        <p>
          Anrede, Vor- und Nachname, Telefon (Festnetz und Mobil), Mieternummer und E-Mail-Adresse des Mieters, Beginn und Ende des Mietvertrags sowie die Vertragsnummer, Adresse (Straße, Hausnummer, Postleitzahl und Ort), Geschosslage des Mietobjekts, Raum, Abrechnungseinheit-Nr., Abrechnungs-Korrespondenznummer, Verbrauchszeitraum, Verbrauch in kWh (bei Wärmemengenzähler), Verbrauch in VE (Verbrauchseinheiten bei Heizkostenverteiler), Verbrauch in m3 (bei Kaltwasserzähler), Faktor, Temperaturdifferenz, Gerätenummer, Vergleich des Verbrauchs für Heizenergie und Warmwasser zum Vorjahr, Vergleich des Verbrauchs für Heizenergie und Warmwasser zum Durchschnittsnutzer.
        </p>

        <h3 class="mt-5 mb-3">Kategorien der betroffenen Personen, deren personenbezogenen Daten verarbeitet werden</h3>

        <ul class="mb-3">
          <li>Kunden</li>
          <li>Mitarbeiter des Kunden</li>
          <li>Mieter des Kunden</li>
        </ul>

        <h3 class="mt-5 mb-3">Zweck der Verarbeitung</h3>

        <p>
          Ausstattung von Liegenschaften mit fernauslesbaren Verbrauchserfassungsgeräten für Heizwärme und/oder Warmwasser in Liegenschaften. Monatliche Erhebung der Verbrauchsdaten und Bereitstellung der monatlichen Verbrauchsinformationen (UVI) zum Heizwärme- und Warmwasserverbrauch in der UVI-Portalsoftware der Vivawest Energiedienstleistungen GmbH zur Weiterleitung an die Mieter.
        </p>

        <h3 class="mt-5 mb-3">Rechtsgrundlagen der Verarbeitung</h3>

        <p>
          Ihre personenbezogenen Daten werden auf Grundlage von Art. 6 Abs. 1 lit. b) und c) DSGVO verarbeitet.
        </p>

        <h3 class="mt-5 mb-3">Empfänger oder Kategorien von Empfängern der personenbezogenen Daten/Drittlandübermittlung</h3>

        <p>
          Die Daten, die wir verarbeiten, werden von uns vertraulich behandelt. Personenbezogene Daten werden von uns grundsätzlich nicht verkauft, verbreitet oder gegen Entgelt Dritten überlassen, sondern dürfen ausschließlich für die in dieser Daten­schutzerklärung genannten Zwecke an Empfänger außerhalb weitergegeben werden. Die Vertraulichkeit und Sicherheit Ihrer Daten werden im Einklang mit unserer Datenschutzerklärung und dem geltenden Recht gewahrt.
        </p>

        <p>
          Die Weitergabe Ihrer Daten z. B. an Behörden, Aufsichtsbehörden und Strafverfolgungsbehörden erfolgt nur im Rahmen der gesetzlichen Vorschriften, wenn es zur Verhinderung und Aufdeckung von Betrugsfällen und sonstigen Straftaten und/oder zur Gewährleistung der Datensicherheit erforderlich ist.
        </p>

        <p>
          Die Bereitstellung des UVI-Portals wird unter Mitwirkung der Trafo2 GmbH, Rosastraße 6a, 45130 Essen. Dies geschieht grundsätzlich auf Basis eines Auftragsverarbeitungsvertrags nach Art. 28 DSGVO. Hiermit ist sichergestellt, dass die Verarbeitung von personenbezogenen Daten im Einklang mit den Bestimmungen der DSGVO erfolgt und alle zur Verarbeitung personenbezogener Daten befugten Personen sich zur Vertraulichkeit verpflichtet haben oder einer angemessenen gesetzlichen Verschwiegenheitspflicht unterliegen.
        </p>

        <p>
          Des Weiteren können wir Dienstleistern Zugriff auf Ihre personenbezogenen Daten gewähren, die im Europäischen Wirtschaftsraum ansässig sind und die wir beauftragen, von uns erfasste Daten zu verarbeiten und/oder unsere Datenbanken im Einklang mit geltendem Recht und dieser Datenschutzerklärung zu speichern, zu warten und zu pflegen.
        </p>

        <p>Ihre Daten übermitteln wir an folgende Kategorien von Empfängern:</p>

        <ul class="mb-3">
          <li>Auftragsverarbeiter (z. B.: Handwerker, Ablesedienste, Rechenzentren)</li>
          <li>Handwerker</li>
          <li>Dienstleister</li>
          <li>Wartungsunternehmen</li>
          <li>Energieversorger</li>
          <li>Kreditinstitute zur Abwicklung des Zahlungsverkehrs</li>
          <li>Auskunfteien • WEG-Verwalter</li>
          <li>Gerichte</li>
          <li>Behörden</li>
          <li>Gläubiger mit titulierten Forderungen</li>
          <li>Berufsgeheimnisträger (z. B. Rechtsanwälte/Notare/Steuerberater/Wirtschaftsprüfer)</li>
          <li>Gerichtsvollzieher/Inkassounternehmen</li>
        </ul>

        <p>Eine Übermittlung von personenbezogenen Daten in Drittländer (EU/EWR-Ausland) erfolgt nicht.</p>

        <h3 class="mt-5 mb-3">Dauer der Speicherung der personenbezogenen Daten</h3>

        <p>
          Unter Beachtung der datenschutzrechtlichen Bestimmungen werden wir grundsätzlich die zu Ihrer Person gespeicherten personenbezogenen Daten auch ohne Ihr Zutun löschen, wenn ihre Kenntnis zur Erfüllung des mit der Speicherung verfolgten Zwecks nicht mehr erforderlich ist, sofern keine anderslautende gesetzliche Verpflichtung gemäß § 257 Handelsgesetz­buch (HGB) und § 147 Abgabenordnung (AO) besteht.
        </p>

        <p>
          Die im UVI-Portal bereitgestellten Verbrauchsdaten werden 24 Monate nach der Bereitstellung gelöscht.
        </p>

        <h3 class="mt-5 mb-3">Erfassung von Serverdaten</h3>

        <p>
          Aus technischen Gründen werden u.a. folgende Daten, die Ihr Internet-Browser übermittelt, erfasst (sogenannte Serverlogfiles):
        </p>

        <p>
          Browsertyp/ Browserversion; verwendetes Betriebssystem; Webseite, von der aus Sie uns besuchen (Referrer URL), falls diese von Ihrem Browser übergeben wird; Webseite, die Sie besuchen; Datum und Uhrzeit Ihres Zugriffs; Ihre Internetprotokoll-/IP-Adresse.<br/>
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Diese Daten werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO erfasst, um mögliche Fehlfunktionen analysieren zu können und das UVI-Portal optimieren zu können. Wir behalten uns vor, diese Daten nachträglich zu prüfen, wenn uns konkrete Anhalts­punkte für eine rechtswidrige Nutzung bekannt werden.
        </p>

        <h3 class="mt-5 mb-3">Verwendung von Sitzungs-Cookies</h3>

        <p>
          Wir verwenden Cookies, um den Besuch der Website attraktiv zu gestalten und die Nutzung bestimmter Funktionen zu ermöglichen. Diese von uns verwendeten Cookies werden nach Ende der Browser-Sitzung wieder von Ihrer Festplatte gelöscht (sog. Session-Cookies).
        </p>

        <h3 class="mt-5 mb-3">Betroffenenrechte</h3>

        <p>Nach der Datenschutz-Grundverordnung stehen Ihnen folgende Rechte zu:</p>

        <p>
          Werden Ihre personenbezogenen Daten verarbeitet, so haben Sie das Recht, Auskunft über die zu Ihrer Person gespeicherten Daten zu erhalten (Art. 15 DSGVO).
        </p>

        <p>
          Sollten unrichtige personenbezogene Daten verarbeitet werden, steht Ihnen ein Recht auf Berichtigung zu (Art. 16 DSGVO).
        </p>

        <p>
          Liegen die gesetzlichen Voraussetzungen vor, so können Sie die Löschung oder Einschränkung der Verarbeitung verlangen sowie Widerspruch gegen die Verarbeitung einlegen (Art. 17, 18 und 21 DSGVO).
        </p>

        <p>
          Wenn Sie in die Datenverarbeitung eingewilligt haben oder ein Vertrag zur Datenverarbeitung besteht und die Datenverarbeitung mithilfe automatisierter Verfahren durchgeführt wird, steht Ihnen gegebenenfalls ein Recht auf Datenübertragbarkeit zu (Art. 20 DSGVO).
        </p>

        <p>
          Weiterhin besteht ein Beschwerderecht beim Landesbeauftragten für Datenschutz und Informationsfreiheit Nordrhein-Westfalen, Kavalleriestr. 2-4, 40213 Düsseldorf, Tel.: 0211/38424-0, E-Mail: <a href="mailto:poststelle@ldi.nrw.de">poststelle@ldi.nrw.de</a>.
        </p>

        <h3 class="mt-5 mb-3">Widerrufsrecht bei Einwilligung</h3>

        <p>
          Wenn Sie in die Verarbeitung durch die Vivawest Energiedienstleistungen GmbH durch eine entsprechende Erklärung eingewilligt haben, können Sie die Einwilligung jederzeit für die Zukunft widerrufen. Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Datenverarbeitung wird durch diesen nicht berührt.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="open = false" block depressed color="primary">
          Schließen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value'],
  emits: ['input'],
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
  },
};
</script>
